import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
// custom hooks
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';

const AuthorsByName = ({ elements, originDetail = false }) => {
  const { assignedLibrary } = useAssignedLibrary();

  const formatAuthorName = (name) => {
    if (!name) return '';

    name = name.trim();

    if (name.includes(',')) {
      const [last, first] = name.split(',').map((part) => part.trim());
      name = `${first} ${last}`;
    }

    return name
      .toLowerCase()
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  return (
    <div className="store-item-authors">
      {elements?.map((value, i) => (
        <React.Fragment key={`authors${i}`}>
          <Link
            className={`store-item-authors__link${originDetail ? '-detail' : ''}`}
            to={`/${assignedLibrary}/autor/${value.url}/`}
            state={value.nombre_autor}
          >
            {formatAuthorName(value.nombre_autor)}
          </Link>
          {i < elements.length - 1 && ', '}
        </React.Fragment>
      ))}
    </div>
  );
};

AuthorsByName.propTypes = {
  elements: PropTypes.array,
  originDetail: PropTypes.bool,
};

export default AuthorsByName;
